import { FSAccessoryData, mapFSAccessoryDatas } from "../Accessory/AccessoryData";
import { FSBrand, mapFSBrand } from "../Brand";
import { FSFileList, mapFSFileLists } from "../FileList";
import { FSLocation, mapFSLocation } from "../Location";
import { FSDataOrder, mapFSDataOrder } from "../Order";
import { FSType, mapFSType } from "../Type";

/* **************************************************** Finishing Shedule Floor Finishing */
export interface FSFloorFinishing {
    fs_data_id?: number;
    data_ff: FSFloorFinishingData[];
    data_accessory?: FSAccessoryData[];
}

export const mapFSFloorFinishing = (data: any): FSFloorFinishing => {
    if (!data || typeof data !== "object") {
        throw new Error("Invalid data for FSFloorFinishing");
    }

    const result: FSFloorFinishing = {
        fs_data_id: data.fs_data_id,
        data_ff: Array.isArray(data.data_ff)
            ? mapFSFloorFinishingDatas(data.data_ff)
            : [],
    };

    if ("data_accessory" in data && Array.isArray(data.data_accessory)) {
        result.data_accessory = mapFSAccessoryDatas(data.data_accessory);
    }

    return result;
};


// Floor finishing data
export interface FSFloorFinishingData {
    id: number;
    fs_feature_id: number;
    location_id: number | null;
    type_id: number | null;
    brand_id: number | null;
    name: string | null;
    note: string | null;
    link: string | null;
    image_path: string | null;
    file_list: FSFileList[];
    order_status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite';
    order_date_data: string | null;
    order_date: string | null;
    order_data: FSDataOrder | null;
    brand: FSBrand | null;
    location: FSLocation | null;
    type: FSType | null;
}

export const mapFSFloorFinishingData = (data: any): FSFloorFinishingData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSFloorFinishingData = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        location_id: data.location_id || null,
        type_id: data.type_id || null,
        brand_id: data.brand_id || null,
        name: data.name || null,
        note: data.note || null,
        link: data.link || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
        order_status: data.order_status,
        order_date_data: data.order_date_data || null,
        order_date: data.order_date || null,
        order_data: data.order_data ? mapFSDataOrder(data.order_data) : null,
        brand: data.brand ? mapFSBrand(data.brand) : null,
        location: data.location ? mapFSLocation(data.location) : null,
        type: data.type ? mapFSType(data.type) : null,
    };

    return res;
};

export const mapFSFloorFinishingDatas = (data: any[]): FSFloorFinishingData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSFloorFinishingData);
};
